import { H1, P } from "orcs-design-system";
import React from "react";
import styled, { keyframes } from "styled-components";

import { copywriting } from "./ErrorPage.config";
import { ErrorContainer } from "./ErrorPageStyles";

const logoAnimation = keyframes`
      0% {
        opacity: 1;
      }

      25% {
        opacity: 1;
      }

      50% {
        opacity: 0;
      }

      100% {
        opacity: 0;
      }
`;

const cogAnimation = keyframes`
      0% {
        opacity: 0;
      }

      40% {
        opacity: 0;
      }

      60% {
        opacity: 1;
      }

      100% {
        opacity: 1;
      }
`;

const cogRotate = keyframes`
      0% {
        transform: translate(-50%,-50%)
                  rotate(0deg);
      }

      100% {
        transform: translate(-50%,-50%)
                  rotate(180deg);
      }`;

const LogoContainer = styled.div`
  position: relative;
  height: 102px;
  width: 200px;
  margin: 0 auto;
  text-align: center;
`;

const Content = styled.div`
  padding: 50px;
  width: 90%;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-family: "Open Sans", sans-serif;
  text-align: center;
`;

const Logo = styled.div`
  display: block;
  position: absolute;
  z-index: 2;
  width: 100px;
  height: auto;
  top: 50%;
  left: 50%;
  svg {
    transform: translate(-50%, -50%);
    animation-duration: 4s;
    animation-name: ${logoAnimation};
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-timing-function: ease-in-out;
  }
`;

const Cog = styled.div`
  display: block;
  position: absolute;
  z-index: 1;
  width: 90px;
  height: auto;
  top: 50%;
  left: 50%;
  svg {
    transform: translate(-50%, -50%);
    animation-duration: 4s, 4s;
    animation-name: ${cogAnimation}, ${cogRotate};
    animation-iteration-count: infinite, infinite;
    animation-direction: alternate, normal;
    animation-timing-function: ease-in-out, linear;
  }
`;

const MaintenancePage = () => {
  return (
    <ErrorContainer
      background="linear-gradient(135deg, rgb(175, 225, 254) 0%, rgb(46, 167, 237) 100%)"
      height="100vh"
      allowSpaceForHeader={false}
    >
      <Content>
        <LogoContainer>
          <Logo>
            <svg
              viewBox="0 0 70 70"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.7252 69.4503C53.9033 69.4503 69.4503 53.9033 69.4503 34.7252C69.4503 15.547 53.9033 0 34.7252 0C15.547 0 0 15.547 0 34.7252C0 53.9033 15.547 69.4503 34.7252 69.4503ZM19.9661 17.3605C21.5607 17.3605 22.9882 18.0761 23.9449 19.2037L44.6038 12.2071C44.6029 12.177 44.6024 12.1469 44.6024 12.1166C44.6024 10.5163 45.8997 9.21907 47.5 9.21907C49.1003 9.21907 50.3975 10.5163 50.3975 12.1166C50.3975 13.7169 49.1003 15.0142 47.5 15.0142C47.3685 15.0142 47.239 15.0054 47.1122 14.9885L38.3402 28.773C38.6702 29.2435 38.8639 29.8166 38.8639 30.4349C38.8639 31.6362 38.1328 32.6668 37.0913 33.1059L42.229 57.3934C43.7565 57.4748 44.9699 58.7391 44.9699 60.2868C44.9699 61.8871 43.6726 63.1844 42.0724 63.1844C40.4721 63.1844 39.1748 61.8871 39.1748 60.2868C39.1748 59.648 39.3815 59.0576 39.7317 58.5786L21.0924 27.6698C20.7297 27.7496 20.3528 27.7917 19.9661 27.7917C17.0856 27.7917 14.7505 25.4566 14.7505 22.5761C14.7505 19.6956 17.0856 17.3605 19.9661 17.3605ZM45.3228 14.0752L36.6968 27.6302C36.4635 27.5696 36.2187 27.5373 35.9663 27.5373C35.1223 27.5373 34.3626 27.8982 33.833 28.474L24.994 23.9678C25.1164 23.5248 25.1817 23.0581 25.1817 22.5761C25.1817 22.0196 25.0946 21.4835 24.9332 20.9806L45.3228 14.0752ZM24.0999 25.7569L33.0706 30.3302C33.0694 30.365 33.0687 30.3998 33.0687 30.4349C33.0687 31.7204 33.9058 32.8103 35.0647 33.1894L39.5538 54.4108L22.9403 26.8612C23.3812 26.5546 23.7725 26.1817 24.0999 25.7569Z"
                fill="white"
              />
            </svg>
          </Logo>
          <Cog>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              x="0"
              y="0"
              viewBox="0 0 32 32"
              xmlSpace="preserve"
              enableBackground="new 0 0 32 32"
            >
              <path
                d="M30.39 12.68l-3.06-0.61c-0.15-0.44-0.34-0.87-0.54-1.29l1.74-2.6c0.53-0.79 0.42-1.85-0.25-2.52l-1.92-1.92c-0.39-0.39-0.9-0.59-1.42-0.59 -0.38 0-0.77 0.11-1.11 0.34L21.23 5.21c-0.42-0.2-0.85-0.38-1.29-0.54L19.32 1.61c-0.19-0.94-1.01-1.61-1.96-1.61h-2.72c-0.95 0-1.77 0.67-1.96 1.61l-0.61 3.07c-0.44 0.15-0.87 0.34-1.29 0.54L8.17 3.48C7.83 3.25 7.45 3.14 7.06 3.14c-0.52 0-1.03 0.2-1.41 0.59L3.73 5.65c-0.67 0.67-0.78 1.73-0.25 2.52l1.74 2.6c-0.2 0.42-0.38 0.85-0.54 1.29l-3.07 0.61C0.67 12.87 0 13.69 0 14.64v2.72c0 0.95 0.67 1.78 1.61 1.96l3.07 0.62c0.15 0.44 0.34 0.87 0.54 1.29l-1.73 2.6c-0.53 0.79-0.42 1.85 0.25 2.52l1.92 1.92c0.39 0.39 0.9 0.59 1.42 0.59 0.38 0 0.77-0.11 1.11-0.34l2.6-1.74c0.42 0.2 0.85 0.38 1.29 0.54l0.61 3.06C12.87 31.33 13.69 32 14.64 32h2.72c0.95 0 1.78-0.67 1.96-1.61l0.62-3.06c0.44-0.15 0.87-0.34 1.29-0.54l2.6 1.74c0.34 0.23 0.73 0.34 1.11 0.34 0.52 0 1.03-0.2 1.42-0.59l1.92-1.92c0.67-0.67 0.78-1.73 0.25-2.52l-1.74-2.6c0.2-0.42 0.38-0.85 0.54-1.29l3.06-0.61C31.33 19.14 32 18.31 32 17.36v-2.72C32 13.69 31.33 12.87 30.39 12.68zM26.93 17.97c-0.69 0.14-1.26 0.64-1.5 1.31 -0.13 0.37-0.28 0.73-0.45 1.07 -0.31 0.64-0.26 1.39 0.14 1.98l1.74 2.6 -1.92 1.92 -2.6-1.74c-0.33-0.22-0.72-0.34-1.11-0.34 -0.3 0-0.6 0.07-0.87 0.2 -0.35 0.17-0.7 0.32-1.08 0.45 -0.67 0.23-1.16 0.8-1.3 1.5L17.36 30h-2.72l-0.61-3.07c-0.14-0.69-0.63-1.26-1.3-1.5 -0.37-0.13-0.73-0.28-1.07-0.45 -0.28-0.13-0.57-0.2-0.87-0.2 -0.39 0-0.77 0.11-1.11 0.34l-2.6 1.74 -1.92-1.92 1.74-2.6c0.39-0.59 0.44-1.34 0.14-1.98 -0.17-0.35-0.32-0.7-0.45-1.08 -0.23-0.67-0.8-1.16-1.5-1.3l-3.06-0.61L2 14.64l3.07-0.61c0.69-0.14 1.26-0.63 1.5-1.3 0.13-0.37 0.28-0.73 0.45-1.07 0.31-0.64 0.26-1.39-0.14-1.98L5.14 7.06l1.92-1.92 2.6 1.74C10 7.1 10.39 7.21 10.78 7.21c0.3 0 0.6-0.07 0.87-0.2 0.35-0.17 0.71-0.32 1.08-0.45 0.67-0.23 1.17-0.8 1.3-1.5l0.61-3.06 2.72 0 0.61 3.07c0.14 0.69 0.64 1.26 1.31 1.5 0.37 0.13 0.73 0.28 1.07 0.45 0.28 0.13 0.57 0.2 0.87 0.2 0.39 0 0.78-0.11 1.11-0.34l2.6-1.73 1.92 1.92 -1.74 2.6c-0.39 0.59-0.44 1.34-0.14 1.98 0.17 0.35 0.32 0.71 0.45 1.08 0.23 0.67 0.8 1.17 1.5 1.3l3.06 0.61L30 17.36 26.93 17.97z"
                fill="white"
              />
              <path
                d="M16 9c-3.86 0-7 3.14-7 7 0 3.87 3.14 7 7 7s7-3.13 7-7S19.86 9 16 9zM16 22.13c-3.38 0-6.12-2.74-6.12-6.12 0-3.38 2.74-6.12 6.13-6.12 3.38 0 6.13 2.74 6.13 6.13C22.13 19.38 19.38 22.13 16 22.13z"
                fill="white"
              />
              <path
                d="M16 12c-2.21 0-4 1.79-4 4 0 2.21 1.79 4 4 4 2.21 0 4-1.79 4-4S18.21 12 16 12zM16 19c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3S17.66 19 16 19z"
                fill="white"
              />
            </svg>
          </Cog>
        </LogoContainer>

        <H1 fontWeight="600" margin=".67em 0em" fontSize="2em">
          {copywriting.maintenancePage.heading}
        </H1>
        <P fontWeight="400" fontSize="1.8rem">
          {copywriting.maintenancePage.detail}
        </P>
      </Content>
    </ErrorContainer>
  );
};

export default MaintenancePage;
